/**
 * Router path for Agentic AI. `useLocation` reports it with the `basename`
 * already stripped, so never run this through `withBasePath` when comparing
 * against a location — only when building a raw `<a href>`, which the router
 * does not resolve.
 */
export const AGENTIC_AI_ROUTE = "/agentic-ai";

export const AGENTIC_AI_AGENT_TOPIC = "analysis_run" as const;

/**
 * Route pattern with the open conversation in the path. The id is optional:
 * the bare route is the welcome screen. Opening from outside, e.g. the "Go to
 * chat" link on the Analysis History detail panel, uses `/agentic-ai/<id>`.
 */
export const AGENTIC_AI_CHAT_ROUTE = `${AGENTIC_AI_ROUTE}/:chatId?`;

/**
 * One entry in the chat history sidebar.
 *
 * `timeLabel` is pre-formatted by the container so the list stays
 * presentational — it never touches a clock.
 */
export type ChatHistoryEntry = {
  id: string;
  title: string;
  timeLabel: string;
};

export const AGENTIC_AI_SIDEBAR_TITLE = "AI Intelligence";

/** Fallback while neither the SDK session nor a selected conversation has a
 * name yet. */
export const AGENTIC_AI_UNTITLED_CHAT = "New chat";

export const AGENTIC_AI_CHAT_HISTORY_HEADING = "Chats";

export const AGENTIC_AI_CHAT_HISTORY_EMPTY =
  "No chats yet. Start a conversation and it will show up here.";

export const AGENTIC_AI_HEADING = "What would you like to explore today?";

export const AGENTIC_AI_DESCRIPTION =
  "Ask anything about locations, markets, competitors, datasets, and business opportunities.";

export const AGENTIC_AI_INPUT_PLACEHOLDER =
  "Ask Agentic AI anything about locations...";

export const AGENTIC_AI_HEADER_PADDING_Y = "py-[1.05rem]";
